import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CurrencyExchangeRateFragment = { id: string, pk: number, currencyCode: string, rate: number };

export const CurrencyExchangeRateFragmentDoc = gql`
    fragment CurrencyExchangeRateFragment on CurrencyExchangeRateType {
  id
  pk
  currencyCode
  rate
}
    `;